<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="ch00_fm06_cont"><a id="page_vii"></a><strong><span class="small">CONTENTS</span></strong></h2>
<p class="tocf"><a class="nounder" href="#/xhtml/ch00_fm07_pre#ch00_fm07_pre"><em>Preface: The Queer Genesis of a Project</em></a></p>
<p class="tocf"><a class="nounder" href="#/xhtml/ch00_fm08_ack#ch00_fm08_ack"><em>Acknowledgments</em></a></p>
<p class="tocf"><a class="nounder" href="#/xhtml/ch00_fm09_intro#ch00_fm09_intro">Introduction: Tropic Spells, Performance, and the Native Boy</a></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch01#ch01" title="Link target outside of Sample">1. A Colonial Dyad in Balinese Performance</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch02#ch02" title="Link target outside of Sample">2. The Global Asian Queer Boys of Singapore</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch03#ch03" title="Link target outside of Sample">3. G.A.P. Drama, or The Gay Asian Princess Goes to the United States</span></p>
<p class="toc1"><span class="nounder" href="#/xhtml/ch04_conclu#ch04_conclu" title="Link target outside of Sample">Conclusion: Toward a Minor-Native Epistemology in Transcolonial Borderzones</span></p>
<p class="toc1"><span class="nounder" href="#/xhtml/ch05_note#ch05_note" title="Link target outside of Sample"><em>Notes</em></span></p>
<p class="toc1"><span class="nounder" href="#/xhtml/ch06_index#ch06_index" title="Link target outside of Sample"><em>Index</em></span></p>
<p class="toc1"><span class="nounder" href="#/xhtml/ch07_about#ch07_about" title="Link target outside of Sample"><em>About the Author</em></span><a id="page_viii"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm06_cont.vue?3857e01a